import { apiClient } from "../../../lib/api-client"
import { ScorecardTemplate, ScorecardCriterionInput } from "../entities/ScorecardTemplate"
import { Scorecard, PanelScorecards } from "../entities/Scorecard"
import { ScorecardRatingInput } from "../entities/ScorecardRating"
import { ScorecardRecommendation } from "../enums/ScorecardRecommendation"

class ScorecardService {
  async getScorecardTemplate(
    organizationId: string,
    vacancyId: string,
  ): Promise<ScorecardTemplate | null> {
    const response = await apiClient.get(
      `/organizations/${organizationId}/vacancies/${vacancyId}/scorecard-template`,
    )
    return response.data
  }

  async saveScorecardTemplate(
    organizationId: string,
    vacancyId: string,
    criteria: ScorecardCriterionInput[],
  ): Promise<ScorecardTemplate> {
    const response = await apiClient.put(
      `/organizations/${organizationId}/vacancies/${vacancyId}/scorecard-template`,
      { criteria },
    )
    return response.data
  }

  async getMyScorecard(
    organizationId: string,
    applicationId: string,
  ): Promise<Scorecard | null> {
    const response = await apiClient.get(
      `/organizations/${organizationId}/applications/${applicationId}/scorecards/me`,
    )
    return response.data
  }

  async saveScorecardDraft(
    organizationId: string,
    applicationId: string,
    payload: {
      interviewId?: string | null
      ratings: ScorecardRatingInput[]
      recommendation?: ScorecardRecommendation | null
      overallNotes?: string | null
    },
  ): Promise<Scorecard> {
    const response = await apiClient.put(
      `/organizations/${organizationId}/applications/${applicationId}/scorecards/me`,
      payload,
    )
    return response.data
  }

  async submitScorecard(
    organizationId: string,
    applicationId: string,
    payload: {
      interviewId?: string | null
      ratings: ScorecardRatingInput[]
      recommendation: ScorecardRecommendation
      overallNotes?: string | null
    },
  ): Promise<Scorecard> {
    const response = await apiClient.post(
      `/organizations/${organizationId}/applications/${applicationId}/scorecards/me/submit`,
      payload,
    )
    return response.data
  }

  async getPanelScorecards(
    organizationId: string,
    applicationId: string,
  ): Promise<PanelScorecards> {
    const response = await apiClient.get(
      `/organizations/${organizationId}/applications/${applicationId}/scorecards/panel`,
    )
    return response.data
  }
}

export const scorecardService = new ScorecardService()
